import { Image, Heading, useTheme } from "@aws-amplify/ui-react";
import logo from "../../assets/images/ACT-logo-horiz.png";

export function Header() {
  const { tokens } = useTheme();

  return (
    <>
      <Image
        alt="logo"
        height="80%"
        width="80%"
        paddingLeft="110px"
        src={logo}
        padding={tokens.space.medium}
      />
      <Heading level={4} padding={`${tokens.space.xl} ${tokens.space.xl} 0`}>
        Sign in to your Account
      </Heading>
    </>  
  );
}
